import React, { Component } from 'react'
import classnames from 'classnames'
import { detectPassiveEventSupport } from '../helpers'

import { InView } from 'react-intersection-observer'
import arrow from '../assets/foam-arrow.svg'

function evalConfig(config) {
  return classnames({
    'zonewrapper-left': config.justification === 'LEFT',
    'zonewrapper-center': config.justification === 'CENTER',
    'zonewrapper-right': config.justification === 'RIGHT',
    'zonewrapper-wide': config.width === 'WIDE',
    'zonewrapper-narrow': config.width === 'NARROW',
    'zonewrapper-narrow zonewrapper-minimal': config.width === 'NARROW-MINIMAL',
    'zonewrapper-large': config.justification === 'LARGE'
  })
}

class MainSection extends Component {
  constructor(props) {
    super(props)
    this.coords = {
      tl: {
        x1: 0,
        y1: 0,
        x2: 0,
        y2: 0
      },
      tr: {
        x1: 0,
        y1: 0,
        x2: 0,
        y2: 0
      },
      bl: {
        x1: 0,
        y1: 0,
        x2: 0,
        y2: 0
      },
      br: {
        x1: 0,
        y1: 0,
        x2: 0,
        y2: 0
      }
    }
    this.canvas = null
    this.sq_tl = null
    this.sq_tr = null
    this.sq_bl = null
    this.sq_br = null
    this.ticking = false
    this.inView = false
    this.noAnim = false
    this.content = this.props.content
  }

  componentWillMount = () => {
    window.scrollTo(0, 0)
    const options = { passive: detectPassiveEventSupport() }
    window.addEventListener('scroll', this.onScroll, options)
    window.addEventListener('resize', this.onResize)
  }

  componentDidMount = () => {
    this.onResize()
  }

  componentWillUnmount = () => {
    window.removeEventListener('scroll', this.onScroll)
    window.removeEventListener('resize', this.onResize)
  }

  update = () => {
    const lastScrollY = this.lastScrollY

    if (lastScrollY < 0 || this.noAnim) {
      this.ticking = false
      return false
    }

    this.coords.tl.x2 = this.sq_tl.getBoundingClientRect().left
    this.coords.tl.y2 = this.sq_tl.getBoundingClientRect().top

    this.coords.tr.x2 = this.sq_tr.getBoundingClientRect().left
    this.coords.tr.y2 = this.sq_tr.getBoundingClientRect().top

    this.coords.bl.x2 = this.sq_bl.getBoundingClientRect().left
    this.coords.bl.y2 = this.sq_bl.getBoundingClientRect().top

    this.coords.br.x2 = this.sq_br.getBoundingClientRect().left
    this.coords.br.y2 = this.sq_br.getBoundingClientRect().top

    const canvas = this.canvas

    if (canvas.getContext) {
      var ctx = canvas.getContext('2d')

      let w = ctx.canvas.clientWidth
      let h = ctx.canvas.clientHeight

      ctx.clearRect(0, 0, w, h)

      ctx.strokeStyle = 'rgba(201,201,201,.65)'

      ctx.lineWidth = 0.6

      // Top left
      ctx.beginPath()
      ctx.moveTo(25, 77)
      ctx.lineTo(this.coords.tl.x2 + 5, this.coords.tl.y2 + 5)
      ctx.closePath()
      ctx.stroke()

      // Top right
      ctx.beginPath()
      ctx.moveTo(w - 25, 77)
      ctx.lineTo(this.coords.tr.x2 + 5, this.coords.tr.y2 + 5)
      ctx.closePath()
      ctx.stroke()

      // Bottom left
      ctx.beginPath()
      ctx.moveTo(25, h - 25)
      ctx.lineTo(this.coords.bl.x2 + 5, this.coords.bl.y2 + 5)
      ctx.closePath()
      ctx.stroke()

      // Bottom right
      ctx.beginPath()
      ctx.moveTo(w - 25, h - 25)
      ctx.lineTo(this.coords.br.x2 + 5, this.coords.br.y2 + 5)
      ctx.closePath()
      ctx.stroke()
    }

    this.ticking = false
  }

  // don't try to do stuff when stuff is already happening
  requestTick = () => {
    if (!this.ticking) {
      window.requestAnimationFrame(this.update)
      this.ticking = true
    }
  }

  onScroll = () => {
    this.lastScrollY = window.scrollY
    this.requestTick()
  }

  onResize = () => {
    const canvas = this.canvas

    if (canvas.getContext) {
      var ctx = canvas.getContext('2d')
      ctx.canvas.width = canvas.offsetWidth
      ctx.canvas.height = canvas.offsetHeight

      this.requestTick()
    }
  }

  onCanvasOut = () => {
    this.noAnim = true
  }

  isInView = (bool, entry) => {
    if (bool) {
      this.noAnim = false
      this.canvas.classList.add('active')
      this.canvas.removeEventListener('transitionend', this.onCanvasOut)
    } else {
      this.canvas.addEventListener('transitionend', this.onCanvasOut)
      this.canvas.classList.remove('active')
    }
  }

  render() {
    const content = this.content
    let windowWidth = window.innerWidth

    return (
      <InView
        threshold="0.6"
        rootMargin="-10% 0% -10% 0%"
        onChange={(inView, entry) => this.isInView(inView, entry)}
      >
        <div className={`zone-outer`}>
          <div className={`zonewrapper-main`}>
            <div className={`zonewrapper-content ${evalConfig(content)}`}>
              <canvas ref={el => (this.canvas = el)} />

              <span className="square tl" ref={el => (this.sq_tl = el)} />
              <span className="square tr" ref={el => (this.sq_tr = el)} />
              <span className="square bl" ref={el => (this.sq_bl = el)} />
              <span className="square br" ref={el => (this.sq_br = el)} />

              {content.h && (
                <div className="title">
                  <h3>Trust Zone</h3>
                  <h3>FOAM Incentivized Location Testnet</h3>
                  <img className="top-arrow" src={arrow} alt="arrow" />
                </div>
              )}

              {content.h && (
                <div className="contentinner">
                  <h1>{content.h}</h1>
                </div>
              )}

              {content.h4 && (
                <div className="contentinner">
                  <h4>{content.h4}</h4>
                  <p>{content.p}</p>
                  {content.a && content.a}
                </div>
              )}

              {content.src && windowWidth >= 600 && (
                <div className="contentinner">
                  <img src={content.src} alt="" />
                </div>
              )}
              {content.src && windowWidth < 600 && (
                <div className="contentinner">
                  <img src={content.smallSrc} alt="" />
                </div>
              )}
              {content.button && (
                <div className="contentinner">
                  <a
                    href="https://cqnllvd8gl2.typeform.com/to/EKlKIoEe"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="sign-up-wrap"
                  >
                    <button className="sign-up-button">
                      <span>{content.button}</span>{' '}
                      <img src={arrow} alt="arrow" />
                    </button>
                  </a>

                  <span className="button-disclaimer">
                    Trust Zone Program applications have closed. Sign up to be
                    notified for the next batch.
                  </span>
                </div>
              )}
            </div>
          </div>
        </div>
      </InView>
    )
  }
}

export { MainSection }



// WEBPACK FOOTER //
// ./src/Components/MainSection.js